import createIcon from '../../createIcon';

/**
 * @component @name FullscreenExit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxNkg4VjE5SDEwVjE0SDVWMTZaTTggOEg1VjEwSDEwVjVIOFY4Wk0xNCAxOUgxNlYxNkgxOVYxNEgxNFYxOVpNMTYgOFY1SDE0VjEwSDE5VjhIMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FullscreenExit = createIcon('FullscreenExit', [
  [
    'path',
    {
      d: 'M5 16H8V19H10V14H5V16ZM8 8H5V10H10V5H8V8ZM14 19H16V16H19V14H14V19ZM16 8V5H14V10H19V8H16Z',
      key: '173bq1',
    },
  ],
]);

export default FullscreenExit;
